// Port of api/fuel/app/classes/controller/api/monty/publishers/suggest.php
import DB from 'offline/db'
import Util from 'offline/util'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = params.exclude || [0]
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })
	var rows = DB.query("SELECT publisher_id, publisher_name FROM publisher WHERE LOWER(publisher_name) LIKE '%" + text.replace(/'/g, "''") + "%' AND publisher_id NOT IN(" + Util.in(exclude) + ") LIMIT 25")
	var suggestions = {}
	for (var i = 0; i < rows.length; i++) suggestions[rows[i].publisher_id] = { id: rows[i].publisher_id, name: rows[i].publisher_name }
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
